export interface SkuDiff {
  field: string;
  from: string;
  to: string;
  type: 'upgrade' | 'downgrade';
}

const GRADE_ORDER = ['CP', 'AA', '0A', '0B', '0C', '0D', 'XX'];
const GRADE_LABELS: Record<string, string> = {
  CP: 'CP',
  AA: 'A+',
  '0A': 'A',
  '0B': 'B',
  '0C': 'C',
  '0D': 'D',
  XX: 'HS'
};

export function computeSkuDiffs(orderSku?: string | null, deviceSku?: string | null): SkuDiff[] {
  if (!orderSku || !deviceSku || orderSku.length !== 35 || deviceSku.length !== 35) return [];

  const diffs: SkuDiff[] = [];

  // Downgrade: color (any difference)
  const orderColor = orderSku.slice(29, 31);
  const deviceColor = deviceSku.slice(29, 31);
  if (orderColor !== deviceColor)
    diffs.push({ field: 'Couleur', from: orderColor, to: deviceColor, type: 'downgrade' });

  // Upgrade or downgrade: grade
  const orderGrade = orderSku.slice(33, 35);
  const deviceGrade = deviceSku.slice(33, 35);
  const orderGradeIdx = GRADE_ORDER.indexOf(orderGrade);
  const deviceGradeIdx = GRADE_ORDER.indexOf(deviceGrade);
  if (deviceGradeIdx !== -1 && orderGradeIdx !== -1 && deviceGradeIdx !== orderGradeIdx) {
    diffs.push({
      field: 'Grade',
      from: GRADE_LABELS[orderGrade] || orderGrade,
      to: GRADE_LABELS[deviceGrade] || deviceGrade,
      type: deviceGradeIdx < orderGradeIdx ? 'upgrade' : 'downgrade'
    });
  }

  // Upgrade or downgrade: hdsize
  const orderHdsize = parseInt(orderSku.slice(21, 25));
  const deviceHdsize = parseInt(deviceSku.slice(21, 25));
  if (deviceHdsize !== orderHdsize) {
    diffs.push({
      field: 'Stockage',
      from: `${orderHdsize} Go`,
      to: `${deviceHdsize} Go`,
      type: deviceHdsize > orderHdsize ? 'upgrade' : 'downgrade'
    });
  }

  // Upgrade or downgrade: ram
  const orderRam = parseInt(orderSku.slice(26, 29));
  const deviceRam = parseInt(deviceSku.slice(26, 29));
  if (deviceRam !== orderRam) {
    diffs.push({
      field: 'RAM',
      from: `${orderRam} Go`,
      to: `${deviceRam} Go`,
      type: deviceRam > orderRam ? 'upgrade' : 'downgrade'
    });
  }

  // Upgrade or downgrade: freq
  const orderFreq = parseInt(orderSku.slice(10, 13));
  const deviceFreq = parseInt(deviceSku.slice(10, 13));
  if (deviceFreq !== orderFreq) {
    const fmt = (v: number) => (v / 100).toFixed(2) + ' GHz';
    diffs.push({
      field: 'Fréquence',
      from: fmt(orderFreq),
      to: fmt(deviceFreq),
      type: deviceFreq > orderFreq ? 'upgrade' : 'downgrade'
    });
  }

  // Upgrade only: year
  const orderYear = parseInt(orderSku.slice(4, 7));
  const deviceYear = parseInt(deviceSku.slice(4, 7));
  if (deviceYear > orderYear)
    diffs.push({ field: 'Année', from: `20${orderYear}`, to: `20${deviceYear}`, type: 'upgrade' });

  return diffs;
}
